import { useEffect, useRef } from 'react';

export const useInitialMount = () => {
  const isInitialMount = useRef(true);
  useEffect(() => {
    if (isInitialMount.current) isInitialMount.current = false;
  }, []);
  return isInitialMount.current;
};
